module.exports = __webpack_public_path__ + "static/media/modis2973.91771403.jpg";